import DateTimePicker from "sap/m/DateTimePicker";
import { InputBase$ChangeEvent } from "sap/m/InputBase";
import UI5Date from "sap/ui/core/date/UI5Date";
import { ValueState } from "sap/ui/core/library";
import { DateTimePicker$ChangeEvent } from "sap/ui/webc/main/DateTimePicker";

/**
 * Extends DateTimePicker to show validation error when user manually enters a badly formatted date/time.
 * Also enables binding "dateValue" to string value.
 * @namespace akademika.akamont.customControls
 */
export default class CustomDateTimePicker extends DateTimePicker {
  public setDateValue(oDateValue: Date | UI5Date | string | null): this {
    if (typeof oDateValue === "string") {
      oDateValue = new Date(oDateValue);
    }
    return super.setDateValue(oDateValue);
  }

  init(): void {
    super.init();
    this.attachChange(this.handleDateTimeChange);
  }

  static renderer = { apiVersion: 2 };

  handleDateTimeChange(oEventArg: InputBase$ChangeEvent) {
    const oEvent = oEventArg as unknown as DateTimePicker$ChangeEvent;
    let isDateValid = oEvent.getParameter("valid");

    if (isDateValid) {
      this.setValueState(ValueState.None);
    } else {
      this.setValueState(ValueState.Error);
    }
  }
}
